import type { StatusMeta } from "@/lib/license";

interface StatusBadgeProps {
  meta: StatusMeta;
}

export default function StatusBadge({ meta }: StatusBadgeProps) {
  return (
    <span
      className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-full px-2.5 py-1 text-xs font-medium ${meta.className}`}
    >
      <span className="h-1.5 w-1.5 rounded-full bg-current opacity-70" />
      {meta.label}
    </span>
  );
}